export function formatDateToShow(date) {
  const timestamp = new Date(date)

  const pad = function (num) {
    var norm = Math.floor(Math.abs(num))
    return (norm < 10 ? '0' : '') + norm
  }

  return `${pad(timestamp.getDate())}/${pad(
    timestamp.getMonth() + 1
  )}/${timestamp.getFullYear()} ${pad(timestamp.getHours())}:${pad(timestamp.getMinutes())}`
}

/**
 * Reduz os caractres de uma string
 *
 * @param {string} string
 * @param {int} size
 * @returns string
 */
export function useTruncateString(string, start = 0, end = 20) {
  return string ? string.substring(start, end) : ''
}
